import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'defaults');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'provider',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'calendar',
    'schedule',
    'defaults',
    {
      type: 'payload.query',
      queryParameter: 'service_id',
      selector: 'serviceId',
    },
    {
      type: 'payload.query',
      queryParameter: 'location_id',
      selector: 'locationId',
    },
    {
      type: 'payload.query',
      queryParameter: 'date',
      selector: 'date',
    },
  ],
});

export default createReqReducer(consts, true);

// /api/provider/:provider_profile_id/calendar/schedule/defaults?service_id=2&location_id=1&date=2020-11-16T00:00:00.000Z



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/schedule-defaults-req.js